<template>
  <section class="test-login-panel">
    <div class="test-login-title">เข้าสู่ระบบสำหรับทดสอบ</div>
    <div class="test-login-grid">
      <select v-model="username" :disabled="loading" aria-label="บัญชีทดสอบ">
        <option value="admin">admin — ผู้ดูแลระบบ</option>
        <option value="user">user — ผู้ใช้งาน</option>
        <option value="super">super — หัวหน้างาน</option>
        <option value="tech">tech — ช่าง</option>
      </select>
      <input
        v-model="password"
        :disabled="loading"
        type="password"
        inputmode="numeric"
        autocomplete="current-password"
        placeholder="รหัสผ่าน"
        aria-label="รหัสผ่านทดสอบ"
        @keyup.enter="login"
      >
    </div>
    <button
      class="test-login-button"
      type="button"
      :disabled="loading || !username || !password"
      @click="login"
    >
      {{ loading ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบทดสอบ' }}
    </button>
    <div class="test-account-hint">
      บัญชี: admin / user / super / tech
    </div>
    <div v-if="errorMessage" class="test-login-error">{{ errorMessage }}</div>
  </section>
</template>

<script>
export default {
  name: 'TestLoginPanel',
  data() {
    return {
      username: 'admin',
      password: '',
      loading: false,
      errorMessage: ''
    }
  },
  methods: {
    async login() {
      if (this.loading || !this.username || !this.password) return

      this.loading = true
      this.errorMessage = ''

      try {
        await this.$store.dispatch('auth/testSignIn', {
          username: this.username,
          password: this.password
        })
      } catch (error) {
        this.errorMessage = error.response?.data?.message === 'INVALID_TEST_CREDENTIALS'
          ? 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง'
          : 'ไม่สามารถเข้าสู่ระบบทดสอบได้'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.test-login-panel {
  margin: 18px 0;
  padding: 16px;
  text-align: left;
  background: rgba(7, 36, 35, .62);
  border: 1px solid rgba(61, 213, 208, .55);
  border-radius: 12px;
}

.test-login-title {
  margin-bottom: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
}

.test-login-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

select,
input {
  width: 100%;
  height: 40px;
  padding: 0 10px;
  color: #153836;
  background: #f4fffe;
  border: 1px solid transparent;
  border-radius: 7px;
  font-size: 13px;
}

select:focus,
input:focus {
  border-color: #3dd5d0;
  outline: none;
  box-shadow: 0 0 0 2px rgba(61, 213, 208, .2);
}

.test-login-button {
  width: 100%;
  height: 40px;
  margin-top: 9px;
  color: #082f2d;
  background: #3dd5d0;
  border: 0;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 700;
}

.test-login-button:disabled {
  cursor: wait;
  opacity: .65;
}

.test-account-hint {
  margin-top: 8px;
  color: #a9d9d7;
  font-size: 11px;
  text-align: center;
}

.test-login-error {
  margin-top: 8px;
  color: #ffaaa5;
  font-size: 12px;
  text-align: center;
}

@media (max-width: 480px) {
  .test-login-grid {
    grid-template-columns: 1fr;
  }
}
</style>

